







module.exports =
	props: ["objects"]



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/breadcrumb.vue